import {createDateTimeFormatter, isIanaTimeZone} from '@fitro/date-time'

/**
 * The customer calendar on a class's own day, in the class's time zone (`/calendar?date=YYYY-MM-DD`),
 * or the calendar itself when the day cannot be told.
 */
export function calendarDayHref(startDateTime?: string | null, timeZone?: string | null): string {
    const dayKey = startDateTime && isIanaTimeZone(timeZone)
        ? createDateTimeFormatter({locale: 'pl', timeZone}).dateKeyInZone(startDateTime)
        : null
    return dayKey ? `/calendar?date=${encodeURIComponent(dayKey)}` : '/calendar'
}
